import * as z from "@-/com.npmjs.zod";

export const betterAuthSocialProviderAvailabilitySchema = z.object({
  apple: z.boolean(),
  google: z.boolean(),
});

export type BetterAuthSocialProviderAvailability = z.infer<
  typeof betterAuthSocialProviderAvailabilitySchema
>;
